<template>
	<form class="list-item list-item-multi-row" @submit.prevent="saveItem" :class="{active:changed}">
		<div class="column">
			<div class="row centering separated">
				<label class="field inline row">
					<span class="label rigid centered">{{label}}</span>
				</label>
				<span class="gap">
					<slot name="success-inline"></slot>
					<slot name="updating-inline"></slot>
				</span>
				<footer class="row rigid">
					<toggle-switch v-model="inputValue" :unchecked-text="'Off'" :checked-text="'On'" :disabled="!canEdit" @change="onChange" class="rigid centered"></toggle-switch>
				</footer>
			</div>

			<div v-if="inputValue" class="row separated">
				<slot name="field-assist"></slot>
			</div>

			<collapsible :min-height="minHeight" :open="newSettingUser">
				<slot class="row centering" name="toggle-block"></slot>
			</collapsible>
		</div>

		<collapsible v-if="requirePassword" :open="changed">

			<div class="legend-footer row centering">
				<!--TODO turn this into a component-->
				<!-- <blockquote v-if="status.error && status.error.authPasswordInvalid" slot="error-inline-footer" class="notice error right gap">
					It appears that this password was wrong.
				</blockquote> -->
				<slot v-if="footerError" name="error-inline-footer"></slot>

				<small v-else class="gap"><i class="fas fa-lock"></i>
					<span v-if="newSettingUser">Two passcodes are </span>
					<span v-else>A password is </span>
					required to change this setting.
				</small>

				<span class="row">
					<input v-if="newSettingUser" placeholder="First code" class="rigid centered code" type="text" v-model="firstCode"/>
					<input v-else placeholder="Account password" class="rigid centered" type="password" v-model="accountPassword"/>
					<span class="hairline"></span>

					<input v-if="newSettingUser" placeholder="Second code" class="rigid centered code" type="text" v-model="secondCode"/>
					<span v-if="newSettingUser" class="hairline"></span>

					<button class="rigid centered" type="submit" :disabled="invalidInput" value="Submit">Apply</button>
				</span>
			</div>

		</collapsible>
	</form>
</template>

<script>
import Vue from 'vue';
import ToggleSwitch from './ToggleSwitch.vue';
import Collapsible from './Collapsible.vue';
export default {
	name: 'SettingToggle',
	data() {
		return {
			firstCode: '',
			secondCode: '',
			accountPassword: '',
			inputValue: this.model,
			changed: false,
			prevSibling: null
		};
	},
	props: {
		label: String,
		model: Boolean,
		onCommit: Function,
		inputRef: String,
		error: Object,
		minHeight: Number,
		requirePassword: Boolean,
		canEdit: Boolean
	},
	components: {
		ToggleSwitch,
		Collapsible
	},
	computed: {
		newSettingUser() {
			return !this.model && this.inputValue;
		},
		invalidInput() {
			return (this.newSettingUser && (this.firstCode.length < 1 || this.secondCode.length < 1)) ||
					(!this.newSettingUser && this.accountPassword < 1);
		},
		footerError(){
			return this.error && !this.error.tfaNotEnabled;
		}
	},
	methods: {
		onChange(val) {
			this.$root.$emit('active', this._uid);
			this.$emit('change', val);

			this.setValue(val);

			this.changed = val !== this.model;
			// select previous selector for styling

			if (!this.$el) {
				return;
			}

			this.prevSibling = this.$el.previousElementSibling;
			if (this.prevSibling && !this.changed) {
				this.prevSibling.classList.remove('prev-item');
			} else {
				this.prevSibling.classList.add('prev-item');
			}
		},
		setValue(val) {
			this.inputValue = val;
		},
		saveItem() {
			const vm = this;
			//TODO: find a better approach here
			this.onCommit(this.firstCode || this.accountPassword, this.secondCode)
				.then(response => {
					vm.resetComponent();
					if (vm.prevSibling) {
						vm.prevSibling.classList.remove('prev-item');
					}
				})
				.catch(error => {

				});
		},
		resetItem(e) {
			this.resetComponent();
			this.$emit('reset');
		},
		resetComponent(e) {
			this.firstCode = '';
			this.secondCode = '';
			this.accountPassword = '';
			this.changed = false;
		},

	},
	watch:{
		model: {
			handler: 'setValue',
			immediate: true
		}
	},
	created() {
		let vm = this;
		this.$root.$on('active', (id) => {
			if (vm._uid !== id) {
				vm.$emit('reset');
				vm.inputValue = vm.model;
				this.resetItem();
			}
		});
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.legend-footer .code {
		width: 125px;
		font-family: Fira mono, monospace;
	}

	footer.row.rigid {
		margin: 9px 0;
	}

	.field-assist {
		position: relative;
		margin-bottom: 0;
		white-space: normal;
		max-width: 75ch;
	}

	@media only screen and (max-width : 600px) {
		.label {
			max-width: 300px;
		}

		.field-assist {
			max-width: 50ch;
		}
	}

	@media only screen and (max-width : 400px) {
		.label {
			max-width: 200px;
		}

		.field-assist {
			max-width: 50ch;
		}
	}

</style>



// WEBPACK FOOTER //
// ./src/components/TheMfaToggle.vue